import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledPageTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 25px;
  backdrop-filter: blur(4px);
  box-shadow: 0px 4px 9.3px 0px #7e8aad4a;
  margin-bottom: 30px;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: ${colors.white};
  width: 100%;

  .title-container {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .title {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.22px;
    color: ${colors.darkBlue};
    margin: 0;
    font-weight: 400;
    white-space: pre-line;
  }

  .logo {
    height: 42px;
    width: auto;
  }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.darkBlue};
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: transparent;
  margin-right: -8px; /* Offset padding to align with title */

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    transform: scale(1.1) translateX(2px);
    color: ${colors.blue};
  }

  &:active {
    transform: scale(0.9) translateX(1px);
    background-color: rgba(0, 0, 0, 0.1);
  }

  svg {
    display: block;
    transition: transform 0.3s ease;
  }

  &:hover svg {
    transform: rotate(5deg);
  }
`;
